module.exports = __webpack_public_path__ + "img/active_button_arrow.d1dd2019.svg";